import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

import axios from "../helpers/axios";
import Layout from "../components/global/Layout";

const Branches = () => {
  const [branches, setBranches] = useState([]);
  const [search, setSearch] = useState("");

  let filtered = branches;

  if (search) {
    filtered = branches.filter((branch) => {
      const fullname = branch.id + " " + branch.name;

      return fullname.toLowerCase().indexOf(search.toLowerCase()) !== -1;
    });
  }

  useEffect(() => {
    axios.get("/api/branch/").then(({ data, status }) => {
      if (status !== 200) {
        return;
      }

      // @TODO implement paginator
      setBranches(data.results);
    });
  }, []);

  return (
    <Layout>
      <div
        className="container"
        style={{
          padding: "2rem",
        }}
      >
        <div className="level">
          <div className="level-left">
            <div className="level-item">
              <h1 className="title is-2">Sucursales</h1>
            </div>
          </div>
          <div className="level-right">
            <div className="level-item">
              <div className="control has-icons-left">
                <input
                  type="text"
                  className="input is-rounded is-medium"
                  placeholder="Buscar por nombre"
                  value={search}
                  onChange={(event) => setSearch(event.target.value)}
                />
                <span className="icon is-left">
                  <FontAwesomeIcon icon={["fas", "search"]} />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="container mt-5"
        style={{
          padding: "2rem",
          backgroundColor: "#f5f5f5",
          borderRadius: "10px",
        }}
      >
        <div className="card">
          <table className="table is-striped is-fullwidth has-text-grey">
            <thead>
              <tr>
                <th>Id</th>
                <th>Sucursal</th>
                <th style={{ width: "1px" }}>Pedidos</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((branch) => (
                <tr key={branch.id}>
                  <td>{branch.id || "-"}</td>
                  <td>{branch.name || "-"}</td>
                  <td className="has-text-left">
                    <Link to={`/branches/${branch.id}`} className="button is-primary is-small">
                      Ver pedidos
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
};

export default Branches;
